import { createFileRoute, redirect } from "@tanstack/react-router";
import {
  BLOG_IMAGE_HEIGHT,
  BLOG_IMAGE_WIDTH,
  blogSocialImagePath,
} from "@/components/marketing/blog-images";
import { BlogPage } from "@/components/marketing/blog-page";
import { MARKETING_FLAGS } from "@/lib/marketing-flags";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/(public)/blog/")({
  beforeLoad: () => {
    if (!MARKETING_FLAGS.blog) {
      throw redirect({ to: "/" });
    }
  },
  head: () =>
    pageHead("blog", {
      image: blogSocialImagePath("best-time-to-post-on-bluesky"),
      imageAlt:
        "A clock and calendar surrounded by many post cards and a nearly level chart",
      imageHeight: BLOG_IMAGE_HEIGHT,
      imageWidth: BLOG_IMAGE_WIDTH,
    }),
  component: BlogPage,
});
